import { useStore } from '~/contexts';
import { useRemovePaymentMethod } from '~/hooks/useRemovePaymentMethod';
import { paymentMethodModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { usePaymentMethods } from './usePaymentMethods';
export function usePaymentMethodsCard(clientId) {
    var _useStore;
    const { paymentMethods, isLoading, isError, refresh } = usePaymentMethods(clientId, {
        refreshOnHookMount: true
    });
    const { removePaymentMethodWithConfirmation } = useRemovePaymentMethod();
    const vendorId = (_useStore = useStore(selectors.user.businessId)) !== null && _useStore !== void 0 ? _useStore : '';
    const apiGatewayHost = useStore((state)=>state.session.apiGatewayHost);
    const onRemovePaymentMethod = (paymentMethod)=>removePaymentMethodWithConfirmation({
            fundingSourceId: paymentMethod.id,
            vendorId,
            customerId: clientId,
            isCreditCard: paymentMethodModel.isCreditCard(paymentMethod),
            last4: paymentMethod.last4,
            onSuccess: refresh
        });
    return {
        paymentMethods,
        isLoading,
        isError,
        vendorId,
        apiGatewayHost,
        refresh: ()=>void refresh({
                throwOnError: false
            }),
        onRemovePaymentMethod
    };
}
